module.exports = __webpack_public_path__ + "img/pro_8.04cd5819.png";